import React, { Component } from 'react'
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
import LayoutFooter from './LayoutFooter'
import layoutHelpers from './helpers'
import SideNav from './SideNav/SideNav'

class Layout2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isToggle: false,
    }
  }

  closeSidenav(e) {
    e.preventDefault()
    layoutHelpers.setCollapsed(true)
  }

  componentDidMount() {
    layoutHelpers.init()
    layoutHelpers.update()
    layoutHelpers.setAutoUpdate(true)
  }

  componentWillUnmount() {
    layoutHelpers.destroy()
  }

  render() {
    return (
      <div className="layout-wrapper layout-2">
        <div className="layout-inner">
          {/* <LayoutSidenav {...this.props} /> */}
          <SideNav isToggle={this.state.isToggle} {...this.props} />

          <div className="layout-container">
            <LayoutNavbar {...this.props} onToggle={e => this.setState({ isToggle: e })} />

            <div className="layout-content">
              <div className="container-fluid flex-grow-1 container-p-y">{this.props.children}</div>

              <LayoutFooter {...this.props} />
            </div>
          </div>
        </div>
        <div className="layout-overlay" onClick={this.closeSidenav}></div>
      </div>
    )
  }
}

export default Layout2
